import { render, staticRenderFns } from "./MemoriesPageAlbum.vue?vue&type=template&id=0e42ad21"
import script from "./MemoriesPageAlbum.vue?vue&type=script&lang=js"
export * from "./MemoriesPageAlbum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports